var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-with-count",class:`${_vm.type}-tag`},[(_vm.type !== 'without-checking')?_c('div',{staticClass:"count"},[_vm._v(_vm._s(_vm.count > 99 ? '99+' : _vm.count))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }